/* eslint-disable */
export class GeoElement {
    name: string | undefined;
    types: string[] | undefined;
}